<ul class="nav--mega print--hidden" role="menu">
    <li class="nav--mega__primary menu-hover"
        [class.is-active]="currentMegaMenuIndex == i && currentMegaMenuIndexToggle == true"
        nav-menu
        [menu-options]="{selector:'.nav--mega__links a', hoverClass:'menu-hover'}"
        *ngFor="let menuItem of filteredMenuItems; let i=index">
        <a href="javascript:void(0);" (click)="megaMenuItemClicked($event)" [attr.data-index]="i" [innerHTML]="menuItem?.securityTransactionTypeMenuItemDisplayValue | highlightKeyword:keyword()"></a>
        <div class="nav--mega__sub">
            <div class="nav--mega__col-container">
                <div class="nav--mega__secondary" *ngFor="let child of menuItem?.children">
                    <ul class="nav--mega__links" #navColLinks>
                        <li><h3 [innerHTML]="child?.securityTransactionTypeMenuItemDisplayValue | highlightKeyword:keyword()"></h3></li>
                        <li *ngFor="let kid of child?.children">
                            <ng-container *ngIf="kid?.menuItemTypeId == 1">
                                <a href="javascript:void(0);" (click)="routeSelected()" [routerLink]="kid?.angularRouteString" *ngIf="kid?.businesstransactionTypeId == null" [innerHTML]="kid?.securityTransactionTypeMenuItemDisplayValue | highlightKeyword:keyword()"></a>
                                <a href="javascript:void(0);" (click)="selectedService(kid.businesstransactionTypeId)" *ngIf="kid?.businesstransactionTypeId != null" [innerHTML]="kid?.securityTransactionTypeMenuItemDisplayValue | highlightKeyword:keyword()"></a>
                            </ng-container>
                            <a *ngIf="kid?.menuItemTypeId == 2" href="javascript:void(0);" (click)="functionRequest(kid.routeString)" [innerHTML]="kid?.securityTransactionTypeMenuItemDisplayValue | highlightKeyword:keyword()"></a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </li>
    <li class="nav--mega__primary" *ngIf="filteredMenuItems?.length == 0">
        <b><em>No matching menu items</em></b>
    </li>
    <li class="nav--mega__filter">
        <form [formGroup]="filterForm">
            <a class="icon--remove" href="javascript:void(0)" title="Clear filter" (click)="clearKeyword()"></a>
            <input class="mvd_form-control" type="text" formControlName="keyword" placeholder="Filter Menu..." />
        </form>
    </li>
</ul>